{
  "name": "vendorv2",
  "version": "0.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build-test": "ng build --configuration=test",
    "build-uat": "ng build --configuration=uat",
    "build-production": "ng build --configuration=production",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^18.2.0",
    "@angular/cdk": "^18.2.3",
    "@angular/common": "^18.2.0",
    "@angular/compiler": "^18.2.0",
    "@angular/core": "^18.2.0",
    "@angular/forms": "^18.2.10",
    "@angular/material": "^18.2.3",
    "@angular/platform-browser": "^18.2.0",
    "@angular/platform-browser-dynamic": "^18.2.0",
    "@angular/router": "^18.2.0",
    "@datadog/browser-logs": "^5.29.0",
    "@datadog/browser-rum": "^5.29.0",
    "@types/bootstrap": "^5.2.10",
    "ag-grid-angular": "^32.2.2",
    "ag-grid-community": "^32.2.2",
    "ag-grid-enterprise": "^33.1.0",
    "bootstrap": "^5.3.3",
    "critters": "^0.0.24",
    "glob": "^11.0.0",
    "inflight": "^1.0.6",
    "lodash": "^4.17.21",
    "moment": "^2.30.1",
    "ngx-loading-reloaded": "^18.0.0",
    "ngx-mask": "^18.0.0",
    "ngx-owl-carousel-o": "^18.0.0",
    "ngx-spinner": "^17.0.0",
    "ngx-toastr": "^19.0.0",
    "rxjs": "~7.8.0",
    "select2": "^4.1.0-rc.0",
    "sweetalert2": "^11.14.5",
    "swiper": "^11.1.14",
    "tslib": "^2.3.0",
    "zone.js": "~0.14.10"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^18.2.1",
    "@angular/cli": "^18.2.1",
    "@angular/compiler-cli": "^18.2.0",
    "@types/jasmine": "~5.1.0",
    "@types/jquery": "^3.5.30",
    "@types/lodash": "^4.17.7",
    "@types/moment": "^2.11.29",
    "@types/node": "^22.5.4",
    "jasmine-core": "~5.2.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "prettier": "^3.3.3",
    "rimraf": "^6.0.1",
    "typescript": "^5.5.4",
    "webpack-bundle-analyzer": "^4.10.2"
  },
  "optionalDependencies": {
    "@rollup/rollup-linux-x64-gnu": "4.9.5"
  }
}
